/**
 * DOS518 — Integrazione ASTUTO
 * xmlParser.ts — Parser XML per export ASTUTO.
 * Gestisce varianti di tag (PascalCase, snake_case, minuscolo).
 */

import type { AstutoIntervento } from '../types';

export function parseXML(content: string): AstutoIntervento {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/xml');

  const parseError = doc.querySelector('parsererror');
  if (parseError) {
    throw new Error('XML non valido: ' + parseError.textContent?.slice(0, 80));
  }

  const get = (tag: string) =>
    doc.querySelector(tag)?.textContent?.trim() ?? '';

  const intervento: AstutoIntervento = {
    codice:     get('CodiceIntervento') || get('codice') || get('ID'),
    data:       get('DataIntervento')   || get('data'),
    ora:        get('OraIntervento')    || get('ora'),
    comune:     get('Comune')           || get('comune'),
    localita:   get('Localita')         || get('localita'),
    latitudine: get('Latitudine')       || get('LAT') || get('lat'),
    longitudine:get('Longitudine')      || get('LON') || get('lon'),
    personale:       [],
    mezziTerrestri:  [],
    mezziAerei:      [],
  };

  // Personale
  doc
    .querySelectorAll('Personale > Persona, personale > persona, Operatore')
    .forEach((p) => {
      const g = (tag: string) => p.querySelector(tag)?.textContent?.trim() ?? '';
      intervento.personale.push({
        matricola: g('Matricola') || g('matricola'),
        nome:      g('Nome')      || g('nome')    || g('name'),
        cognome:   g('Cognome')   || g('cognome') || g('surname'),
        qualifica: g('Qualifica') || g('qualifica')|| g('ruolo'),
        telefono:  g('Telefono')  || g('telefono')|| g('cellulare'),
        radio:     g('Radio')     || g('radio')   || g('canale'),
        ente:      g('Ente')      || g('ente'),
      });
    });

  // Mezzi Terrestri
  doc
    .querySelectorAll('MezziTerrestri > Mezzo, mezzi_terrestri > mezzo, MezzoTerrestre')
    .forEach((m) => {
      const g = (tag: string) => m.querySelector(tag)?.textContent?.trim() ?? '';
      intervento.mezziTerrestri.push({
        sigla: g('Sigla') || g('sigla') || g('codice') || g('ID'),
        tipo:  g('Tipo')  || g('tipo')  || g('tipologia'),
        targa: g('Targa') || g('targa'),
        ente:  g('Ente')  || g('ente')  || g('provenienza'),
      });
    });

  // Mezzi Aerei
  doc
    .querySelectorAll('MezziAerei > Mezzo, mezzi_aerei > mezzo, MezzoAereo')
    .forEach((m) => {
      const g = (tag: string) => m.querySelector(tag)?.textContent?.trim() ?? '';
      intervento.mezziAerei.push({
        sigla:   g('Sigla')   || g('sigla')   || g('codice') || g('ID'),
        tipo:    g('Tipo')    || g('tipo'),
        modello: g('Modello') || g('modello'),
      });
    });

  return intervento;
}
